import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { palette } from '@awarego-ui/components';

const NavWrap = styled.div`
    display: flex;
    gap: 4px;
    border-bottom: 1px solid ${palette.graphite.silver};
    margin-bottom: 24px;
`;

const TabLink = styled(Link)`
    font-size: 13px;
    font-weight: 600;
    padding: 10px 16px;
    color: ${({ $active }) =>
        $active ? palette.graphite.onyx : palette.graphite.charcoal};
    border-bottom: 2px solid
        ${({ $active }) =>
            $active ? palette.evergreen.aspargus : 'transparent'};
    margin-bottom: -1px;
    text-decoration: none;
    cursor: pointer;
    background: transparent;
    transition: color 0.1s;

    &:hover {
        color: ${palette.graphite.onyx};
        text-decoration: none;
    }
`;

const TABS = [
    { code: '', title: 'Dashboard' },
    { code: 'campaigns', title: 'Campaigns' },
];

export default function AwareExposeSubNav({ active }) {
    const { pathname } = useLocation();
    return (
        <NavWrap>
            {TABS.map((t) => {
                const to = `/aware-expose${t.code ? `/${t.code}` : ''}`;
                const isActive =
                    active != null
                        ? active === t.code
                        : t.code
                        ? pathname.startsWith(to)
                        : pathname === to || pathname === '/aware-expose';
                return (
                    <TabLink key={t.code} to={to} $active={!!isActive}>
                        {t.title}
                    </TabLink>
                );
            })}
        </NavWrap>
    );
}
